namespace SPA {
	export namespace Realtor {
		export namespace gui {
			export class Adviser {
				public static Build(objectID: string, data: []): JQuery
				{
					if (data.length === 1) {
						data = data[0];
					}
					
					const html = `
					<fieldset class="form-horizontal less-more-container">
						<legend>Betreuer <small class="less-more-trigger">mehr anzeigen</small></legend>
						<div class="row">
							<div class="col-xs-6">
								<input class="form-control" type="text" name="address.search" data-type="adviser" placeholder="Betreuer suchen" />
							</div>
							<div class="col-xs4">
								<button class="btn btn-primary" type="button">Neuen Betreuer anlegen/ersetzen</button>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-2">
								<label class="control-label">Anrede</label>
								<select class="form-control" name="salutation">
									<option value="" selected> --- </option>
									<option value="Herr">Herr</option>
									<option value="Frau">Frau</option>
								</select>
							</div>
							<div class="col-sm-2">
								<label class="control-label">Titel</label>
								<input class="form-control" type="text" name="title" value="${data.title || ''}" />
							</div>
							<div class="col-sm-4">
								<label class="control-label">Nachname</label>
								<input class="form-control" type="text" name="surname" value="${data.surname || ''}" />
							</div>
							<div class="col-sm-4">
								<label class="control-label">Vorname</label>
								<input class="form-control" type="text" name="name" value="${data.name || ''}" />
							</div>
						</div>
						<div class="less-more less-more-hidden">
							<div class="row">
								<div class="col-sm-8">
								<label class="control-label">Firma</label>
									<input class="form-control" type="text" name="company" value="${data.company || ''}" />
								</div>
								<div class="col-sm-4">
								<label class="control-label">Auftrag bis</label>
										<input class="form-control" type="date" name="mandatetill" value="${data.mandatetill || ''}" />
								</div>
							</div>
							<div class="row">
								<div class="col-sm-8">
									<label class="control-label">Straße</label>
									<input class="form-control" type="text" name="street" value="${data.street || ''}" />
								</div>
								<div class="col-sm-2">
								<label class="control-label">Haus-Nr.</label>
									<input class="form-control" type="text" name="housenumber" value="${data.housenumber || ''}" />
								</div>
							</div>
							<div class="row">
								<div class="col-sm-2">
									<label class="control-label">PLZ</label>
									<input class="form-control" type="text" name="postalcode" value="${data.postalcode || ''}" />
								</div>
								<div class="col-sm-6">
									<label class="control-label">Ort</label>
									<input class="form-control" type="text" name="city" value="${data.city || ''}" />
								</div>
								<div class="col-sm-4">
									<label class="control-label">Land</label>
									<select class="form-control" name="country">
										<option value="de">Deutschland</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-4">
									<label class="control-label">Telefon</label>
									<input class="form-control" type="text" name="phone" value="${data.phone || ''}" />
								</div>
								<div class="col-sm-4">
									<label class="control-label">Mobil</label>
									<input class="form-control" type="text" name="mobile" value="${data.mobile || ''}" />
								</div>
								<div class="col-sm-4">
									<label class="control-label">E-Mail</label>
									<input class="form-control" type="text" name="email" value="${data.email || ''}" />
								</div>
							</div>
						</div>
					</fieldset>`;

					return $(html);
				}

			}
		}
	}
}
